document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.getElementById("stickyQty");
  const plusBtn = document.querySelector(".qty-btn.plus");
  const minusBtn = document.querySelector(".qty-btn.minus");
  const addToCartBtn = document.getElementById("stickyAddToCart");
  const stickyCart = document.getElementById("stickyCart");
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const mainQty = document.querySelector('input[name="quantity"]'); // Shopify main qty
  const mainAddBtn =
    (productForm?.querySelector('button[type="submit"]') ??
      document.querySelector('form[action*="/cart/add"] button[type="submit"]'));

  // If sticky UI isn't on the page, don't attach listeners.
  if (!qtyInput || !plusBtn || !minusBtn || !addToCartBtn || !stickyCart) return;

  // Sync quantity with main product
  function syncQty(value) {
    qtyInput.value = value;
    if (mainQty) {
      mainQty.value = value;
      mainQty.dispatchEvent(new Event("change"));
    }
  }

  // Plus
  plusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    val++;
    syncQty(val);
  });

  // Minus
  minusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val > 1) {
      val--;
      syncQty(val);
    }
  });

  // Manual input
  qtyInput.addEventListener("input", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val < 1) val = 1;
    syncQty(val);
  });

  // Add to cart
addToCartBtn.addEventListener("click", () => {
  if (!mainAddBtn) return;

  // Disable button
  addToCartBtn.disabled = true;
  addToCartBtn.textContent = "Adding...";

  // Trigger Shopify add to cart
  mainAddBtn.click();

  // Re-enable after delay (fallback)
  setTimeout(() => {
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = "Add to Cart";
  }, 5000);
});


window.addEventListener("scroll", () => {
  if (!productForm) return;
  const rect = productForm.getBoundingClientRect();

  if (rect.bottom < 0) {
    stickyCart.style.display = "flex";
  } else {
    stickyCart.style.display = "none";
  }
});

});
